import React from "react";
import Footer from "../../components/Layout/Footer";
import Header from "../../components/Layout/Header";
import Layout from "../../components/Layout/Layout";

import ReturnsForm from "./ReturnsForm";
import ReturnsSlice1 from "./ReturnsSlice1";
import ReturnsSlice2 from "./ReturnsSlice2";
import ReturnsSlice3 from "./ReturnsSlice3";
import ReturnsSlice4 from "./ReturnsSlice4";
import ReturnsSlice5 from "./ReturnsSlice5";

import styled from "styled-components";
import HorizontalScroll from "react-scroll-horizontal";

const StyledBodyContainer = styled.div``;

const StaticReturns = () => {
  return (
    <Layout>
      {/*  Header */}
      <Header showBuildMyBed={true} showCart={true} cartIconColor={"black"} />
      {/*  Body */}
      <StyledBodyContainer
        style={{
          margin: "0 auto",
          height: "90vh",
          overflowX: "auto",
          overflowY: "hidden",
          overscrollBehavior: "contain",
          padding: "1rem 1.0875rem 1.45rem",
          zIndex: 300,
        }}
      >
        <HorizontalScroll reverseScroll={true}>
          <div
            className="row"
            style={{
              width: "4200px",
              overflow: "show",
              marginLeft: "13vw",
            }}
          >
            <ReturnsSlice1 />
            <ReturnsSlice2 />
            <ReturnsSlice3 />
            <ReturnsSlice4 />
            {/*<ReturnsSlice5 />*/}
            <ReturnsForm></ReturnsForm>
          </div>
        </HorizontalScroll>
      </StyledBodyContainer>
      {/*  Footer */}
      <Footer showMenuButton={true} styles={{ zIndex: 1100 }}></Footer>
    </Layout>
  );
};

export default StaticReturns;
